<template>
  <div class="row main-content">
    <div class="col">
      <h1 class="page-title font-custom text-uppercase mt-3">
        {{ $t('title.authorization.details') }}
      </h1>

      <div class="card card-body bg-light mb-4">
        <button
          type="button"
          class="btn btn-primary font-inverted rounded-pill font-custom btn-export"
          @click="downloadCSV()"
        >
          <i class="far fa-file-excel me-1" />
          {{ $t('button.export') }}
        </button>
      </div>

      <div v-if="authorization">
        <div
          id="accordionGeneralData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingGeneralData"
            data-bs-toggle="collapse"
            href="#collapseGeneralData"
            aria-expanded="true"
            aria-controls="collapseGeneralData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.generalData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip1')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapseGeneralData"
            aria-labelledby="headingGeneralData"
            data-bs-parent="#accordionGeneralData"
            class="card-body collapse show"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.referenceDistributeur') }}
              </div>
              <div class="col">
                {{ authorization.referenceDistributeur }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.typeTransaction') }}
              </div>
              <div class="col">
                {{ authorization.typeTransaction }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.dateTransaction') }}
              </div>
              <div class="col">
                {{ $filters.date(authorization.dateTransaction) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.dateTransmissionTransaction') }}
              </div>
              <div class="col">
                {{ $filters.dateTransmission(authorization.dateTransmissionTransaction) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.dateMoveUp') }}
              </div>
              <div class="col">
                {{ $filters.date(authorization.dateMoveUp) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.numAut') }}
              </div>
              <div class="col">
                {{ authorization.numAut }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.codeRetour') }}
              </div>
              <div class="col">
                {{ authorization.codeRetour }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.codeRaisonDetaillee') }}
              </div>
              <div class="col">
                {{ authorization.codeRaisonDetaillee }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.referenceListe') }}
              </div>
              <div class="col">
                {{ authorization.referenceListe }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.canalAcceptationValue') }}
              </div>
              <div class="col">
                {{ $filters.uppercase(authorization.canalAcceptationValue) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.idAcceptation') }}
              </div>
              <div class="col">
                {{ authorization.idAcceptation }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.acquirerCountryCode') }}
              </div>
              <div class="col">
                {{ authorization.acquirerCountryCode }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.idTerminal') }}
              </div>
              <div class="col">
                {{ authorization.idTerminal }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.traceNumber') }}
              </div>
              <div class="col">
                {{ authorization.traceNumber }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.posEntryMode') }}
              </div>
              <div class="col">
                {{ authorization.posEntryMode }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.ert') }}
              </div>
              <div class="col">
                {{ authorization.ert }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.functionCode') }}
              </div>
              <div class="col">
                {{ authorization.functionCode }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.scheme') }}
              </div>
              <div class="col">
                {{ authorization.scheme }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.mask') }}
              </div>
              <div class="col">
                {{ authorization.mask }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.typeFacture') }}
              </div>
              <div class="col">
                {{ authorization.typeFacture }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.regularizationFlag') }}
              </div>
              <div class="col">
                {{ authorization.regularizationFlag }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.authorizationReference') }}
              </div>
              <div class="col">
                {{ authorization.authorizationReference }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.retrievalReferenceNumber') }}
              </div>
              <div class="col">
                {{ authorization.retrievalReferenceNumber }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.referenceProduit') }}
              </div>
              <div class="col">
                {{ authorization.referenceProduit }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.preAuthorizationFlag') }}
              </div>
              <div class="col">
                {{ authorization.preAuthorizationFlag }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.posData') }}
              </div>
              <div class="col">
                {{ authorization.posData }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.traceId') }}
              </div>
              <div class="col">
                {{ authorization.traceId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.transactionLinkId') }}
              </div>
              <div class="col">
                {{ authorization.transactionLinkId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.transactionReference') }}
              </div>
              <div class="col">
                {{ authorization.transactionReference }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.merchantSingleTapIndicator') }}
              </div>
              <div class="col">
                {{ authorization.merchantSingleTapIndicator }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.codeMotifAutorisationSingleTap') }}
              </div>
              <div
                v-if="!authorization.typeTransaction.includes('0120')"
                class="col"
              >
                {{ authorization.avisCodeMotif }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardholderMerchantInitiatorTrInd') }}
              </div>
              <div class="col">
                {{ authorization.cardholderMerchantInitiatorTrInd }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.finalAuthorizationIndicator') }}
              </div>
              <div class="col">
                {{ authorization.finalAuthorizationIndicator }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.regularizationOrigine') }}
              </div>
              <div class="col">
                {{ authorization.regularizationOrigine }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.directSettlementMode') }}
              </div>
              <div class="col">
                {{ authorization.directSettlementMode }}
              </div>
            </div>
            <div
              v-if="!!authorization.saerDeclined"
              class="row"
            >
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.saerDeclined') }}
              </div>
              <div class="col">
                {{ authorization.saerDeclined }}
              </div>
            </div>
            <div
              v-if="!!authorization.idAppel"
              class="row"
            >
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.idAppel') }}
              </div>
              <div class="col">
                {{ authorization.idAppel }}
              </div>
            </div>
            <div
              v-if="!!authorization.networkOrigin"
              class="row"
            >
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.networkOrigin') }}
              </div>
              <div class="col">
                {{ authorization.networkOrigin }}
              </div>
            </div>
            <div
              v-if="!!authorization.protocole"
              class="row"
            >
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.protocole') }}
              </div>
              <div class="col">
                {{ authorization.protocole }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip1"
              class="d-none"
            >
              {{ $t('label.authorization.detail.referenceDistributeur') }} : {{ authorization.oriAuthorization.referenceDistributeur }} &lt;br&gt;
              {{ $t('label.authorization.detail.typeTransaction') }} : {{ authorization.oriAuthorization.typeTransaction }} &lt;br&gt;
              {{ $t('label.authorization.detail.dateTransaction') }} : {{ $filters.date(authorization.oriAuthorization.dateTransaction) }} &lt;br&gt;
              {{ $t('label.authorization.detail.dateTransmissionTransaction') }} : {{ $filters.dateTransmission(authorization.oriAuthorization.dateTransmissionTransaction) }} &lt;br&gt;
              {{ $t('label.authorization.detail.dateMoveUp') }} : {{ $filters.date(authorization.oriAuthorization.dateMoveUp) }} &lt;br&gt;
              {{ $t('label.authorization.detail.numAut') }} : {{ authorization.oriAuthorization.numAut }} &lt;br&gt;
              {{ $t('label.authorization.detail.codeRetour') }} : {{ authorization.oriAuthorization.codeRetour }} &lt;br&gt;
              {{ $t('label.authorization.detail.codeRaisonDetaillee') }} : {{ authorization.oriAuthorization.codeRaisonDetaillee }} &lt;br&gt;
              {{ $t('label.authorization.detail.canalAcceptationValue') }} : {{ $filters.uppercase(authorization.oriAuthorization.canalAcceptationValue) }} &lt;br&gt;
              {{ $t('label.authorization.detail.idAcceptation') }} : {{ authorization.oriAuthorization.idAcceptation }} &lt;br&gt;
              {{ $t('label.authorization.detail.countryCode') }} : {{ authorization.oriAuthorization.countryCode }} &lt;br&gt;
              {{ $t('label.authorization.detail.idTerminal') }} : {{ authorization.oriAuthorization.idTerminal }} &lt;br&gt;
              {{ $t('label.authorization.detail.traceNumber') }} : {{ authorization.oriAuthorization.traceNumber }} &lt;br&gt;
              {{ $t('label.authorization.detail.posEntryMode') }} : {{ authorization.oriAuthorization.posEntryMode }} &lt;br&gt;
              {{ $t('label.authorization.detail.ert') }} : {{ authorization.oriAuthorization.ert }} &lt;br&gt;
              {{ $t('label.authorization.detail.functionCode') }} : {{ authorization.oriAuthorization.functionCode }} &lt;br&gt;
              {{ $t('label.authorization.detail.scheme') }} : {{ authorization.oriAuthorization.scheme }} &lt;br&gt;
              {{ $t('label.authorization.detail.mask') }} : {{ authorization.oriAuthorization.mask }} &lt;br&gt;
              {{ $t('label.authorization.detail.typeFacture') }} : {{ authorization.oriAuthorization.typeFacture }} &lt;br&gt;
              {{ $t('label.authorization.detail.regularizationFlag') }} : {{ authorization.oriAuthorization.regularizationFlag }} &lt;br&gt;
              {{ $t('label.authorization.detail.authorizationReference') }} : {{ authorization.oriAuthorization.authorizationReference }} &lt;br&gt;
              {{ $t('label.authorization.detail.referenceProduit') }} : {{ authorization.oriAuthorization.referenceProduit }} &lt;br&gt;
              {{ $t('label.authorization.detail.preAuthorizationFlag') }} : {{ authorization.oriAuthorization.preAuthorizationFlag }} &lt;br&gt;
              {{ $t('label.authorization.detail.posData') }} : {{ authorization.oriAuthorization.posData }} &lt;br&gt;
              {{ $t('label.authorization.detail.traceId') }} : {{ authorization.oriAuthorization.traceId }} &lt;br&gt;
              {{ $t('label.authorization.detail.transactionLinkId') }} : {{ authorization.oriAuthorization.transactionLinkId }} &lt;br&gt;
              {{ $t('label.authorization.detail.merchantSingleTapIndicator') }} : {{ authorization.oriAuthorization.merchantSingleTapIndicator }} &lt;br&gt;
              <span v-if="!authorization.typeTransaction.includes('0120')">
                {{ $t('label.authorization.detail.codeMotifAutorisationSingleTap') }} : {{ authorization.oriAuthorization.avisCodeMotif }}
              </span>
              <span v-if="authorization.typeTransaction.includes('0120')">
                {{ $t('label.authorization.detail.codeMotifAutorisationSingleTap') }} :
              </span> &lt;br&gt;
              {{ $t('label.authorization.detail.finalAuthorizationIndicator') }} : {{ authorization.oriAuthorization.finalAuthorizationIndicator }} &lt;br&gt;
              {{ $t('label.authorization.detail.regularizationOrigine') }} : {{ authorization.oriAuthorization.regularizationOrigine }} &lt;br&gt;
              {{ $t('label.authorization.detail.directSettlementMode') }} : {{ authorization.oriAuthorization.directSettlementMode }} &lt;br&gt;
              {{ $t('label.authorization.detail.saerDeclined') }} : {{ authorization.oriAuthorization.saerDeclined }} &lt;br&gt;
              {{ $t('label.authorization.detail.idAppel') }} : {{ authorization.oriAuthorization.idAppel }} &lt;br&gt;
              {{ $t('label.authorization.detail.networkOrigin') }} : {{ authorization.oriAuthorization.networkOrigin }} &lt;br&gt;
              {{ $t('label.authorization.detail.protocole') }} : {{ authorization.oriAuthorization.protocole }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionMarchandData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingMarchandData"
            data-bs-toggle="collapse"
            href="#collapseMarchandData"
            aria-expanded="false"
            aria-controls="collapseMarchandData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.marchandData') }} <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip2')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapseMarchandData"
            aria-labelledby="headingMarchandData"
            data-bs-parent="#accordionMarchandData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.idContratAffilie') }}
              </div>
              <div class="col">
                {{ authorization.idContratAffilie }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.idMarchand') }}
              </div>
              <div class="col">
                {{ authorization.idMarchand }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.nomMarchand') }}
              </div>
              <div class="col">
                {{ authorization.nomMarchand }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.villeMarchand') }}
              </div>
              <div class="col">
                {{ authorization.villeMarchand }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.codepostalMarchand') }}
              </div>
              <div class="col">
                {{ authorization.codepostalMarchand }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.paysMarchand') }}
              </div>
              <div class="col">
                {{ authorization.paysMarchand }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.idStructure') }}
              </div>
              <div class="col">
                {{ authorization.idStructure }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.codeMCC') }}
              </div>
              <div class="col">
                {{ authorization.codeMCC }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.domesticAcceptorTaxId') }}
              </div>
              <div
                class="col"
                style="white-space: pre-wrap;"
              >
                {{ authorization.domesticAcceptorTaxId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.accountCategory') }}
              </div>
              <div class="col">
                {{ authorization.accountCategory }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.accountNumber') }}
              </div>
              <div class="col">
                {{ authorization.accountNumber }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.paymentFacilitatorId') }}
              </div>
              <div
                class="col"
                style="white-space: pre-wrap;"
              >
                {{ authorization.paymentFacilitatorId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.independentSalesOrgId') }}
              </div>
              <div
                class="col"
                style="white-space: pre-wrap;"
              >
                {{ authorization.independentSalesOrgId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.subMerchantId') }}
              </div>
              <div class="col">
                {{ authorization.subMerchantId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.merchantCountryOrigin') }}
              </div>
              <div class="col">
                {{ authorization.merchantCountryOrigin }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.partialAuthorizationSupported') }}
              </div>
              <div class="col">
                {{ authorization.partialAuthSupported === 'PARTIAL_AUTH_SUPPORTED' ? $t('label.authorization.detail.partialAuthYes') : $t('label.authorization.detail.partialAuthNo') }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip2"
              class="d-none"
            >
              {{ $t('label.authorization.detail.idContratAffilie') }} : {{ authorization.oriAuthorization.idContratAffilie }} &lt;br&gt;
              {{ $t('label.authorization.detail.idMarchand') }} : {{ authorization.oriAuthorization.idMarchand }} &lt;br&gt;
              {{ $t('label.authorization.detail.nomMarchand') }} : {{ authorization.oriAuthorization.nomMarchand }} &lt;br&gt;
              {{ $t('label.authorization.detail.villeMarchand') }} : {{ authorization.oriAuthorization.villeMarchand }} &lt;br&gt;
              {{ $t('label.authorization.detail.codepostalMarchand') }} : {{ authorization.oriAuthorization.codepostalMarchand }} &lt;br&gt;
              {{ $t('label.authorization.detail.paysMarchand') }} : {{ authorization.oriAuthorization.paysMarchand }} &lt;br&gt;
              {{ $t('label.authorization.detail.idStructure') }} : {{ authorization.oriAuthorization.idStructure }} &lt;br&gt;
              {{ $t('label.authorization.detail.codeMCC') }} : {{ authorization.oriAuthorization.codeMCC }} &lt;br&gt;
              {{ $t('label.authorization.detail.accountCategory') }} : {{ authorization.oriAuthorization.accountCategory }} &lt;br&gt;
              {{ $t('label.authorization.detail.accountNumber') }} : {{ authorization.oriAuthorization.accountNumber }} &lt;br&gt;
              {{ $t('label.authorization.detail.paymentFacilitatorId') }} : {{ authorization.oriAuthorization.paymentFacilitatorId }} &lt;br&gt;
              {{ $t('label.authorization.detail.independentSalesOrgId') }} : {{ authorization.oriAuthorization.independentSalesOrgId }} &lt;br&gt;
              {{ $t('label.authorization.detail.subMerchantId') }} : {{ authorization.oriAuthorization.subMerchantId }} &lt;br&gt;
              {{ $t('label.authorization.detail.merchantCountryOrigin') }} : {{ authorization.oriAuthorization.merchantCountryOrigin }} &lt;br&gt;
              {{ $t('label.authorization.detail.partialAuthorizationSupported') }} : {{ authorization.oriAuthorization.partialAuthSupported === 'PARTIAL_AUTH_SUPPORTED' ? $t('label.authorization.detail.partialAuthYes') : $t('label.authorization.detail.partialAuthNo') }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionPorteurData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingPorteurData"
            data-bs-toggle="collapse"
            href="#collapsePorteurData"
            aria-expanded="false"
            aria-controls="collapsePorteurData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.porteurData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip3')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapsePorteurData"
            aria-labelledby="headingPorteurData"
            data-bs-parent="#accordionPorteurData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.numCarte') }}
              </div>
              <div class="col">
                {{ authorization.numCarte }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.psnCarte') }}
              </div>
              <div class="col">
                {{ authorization.psnCarte }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardId') }}
              </div>
              <div class="col">
                {{ authorization.cardId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardExpiryDate') }}
              </div>
              <div class="col">
                {{ authorization.cardExpiryDate }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.referenceContratFinanceur') }}
              </div>
              <div class="col">
                {{ authorization.referenceContratFinanceur }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.referenceServiceBeneficiaire') }}
              </div>
              <div class="col">
                {{ authorization.referenceServiceBeneficiaire }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip3"
              class="d-none"
            >
              {{ $t('label.authorization.detail.numCarte') }} : {{ authorization.oriAuthorization.numCarte }} &lt;br&gt;
              {{ $t('label.authorization.detail.psnCarte') }} : {{ authorization.oriAuthorization.psnCarte }} &lt;br&gt;
              {{ $t('label.authorization.detail.cardId') }} : {{ authorization.oriAuthorization.cardId }} &lt;br&gt;
              {{ $t('label.authorization.detail.cardExpiryDate') }} : {{ authorization.oriAuthorization.cardExpiryDate }} &lt;br&gt;
              {{ $t('label.authorization.detail.referenceContratFinanceur') }} : {{ authorization.oriAuthorization.referenceContratFinanceur }} &lt;br&gt;
              {{ $t('label.authorization.detail.referenceServiceBeneficiaire') }} : {{ authorization.oriAuthorization.referenceServiceBeneficiaire }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionMonetaireData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingMonetaireData"
            data-bs-toggle="collapse"
            href="#collapseMonetaireData"
            aria-expanded="false"
            aria-controls="collapseMonetaireData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.monetaireData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip4')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapseMonetaireData"
            aria-labelledby="headingMonetaireData"
            data-bs-parent="#accordionMonetaireData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.amount') }}
              </div>
              <div class="col">
                {{ $filters.currency(authorization.amount, authorization.currencyCode) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.currencyCode') }}
              </div>
              <div class="col">
                {{ authorization.currencyCode }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.feeAmountAndSign') }}
              </div>
              <div
                v-if="authorization.feeAmountSign || authorization.feeAmount"
                class="col"
              >
                {{ $filters.nullFilter($filters.currency(authorization.feeAmount, authorization.currencyCode)) + ' | ' + $filters.nullFilter(authorization.feeAmountSign) }}
                <span
                  :title="$t('label.authorization.detail.sameCurrency')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  class="label label-default ms-1"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.replacementAmount') }}
              </div>
              <div class="col">
                {{ $filters.currency(authorization.replacementAmount, authorization.currencyCode) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardholderAmount') }}
              </div>
              <div class="col">
                {{ $filters.currency(authorization.cardholderAmount, authorization.cardholderCurrency ? authorization.cardholderCurrency : authorization.currencyCode) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardholderCurrency') }}
              </div>
              <div class="col">
                {{ authorization.cardholderCurrency }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardholderConversionRate') }}
              </div>
              <div class="col">
                {{ authorization.cardholderConversionRate }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardholderReplacementAmount') }}
              </div>
              <div class="col">
                {{ $filters.currency(authorization.cardholderReplacementAmount, authorization.cardholderCurrency ? authorization.cardholderCurrency : authorization.currencyCode) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.solde') }}
              </div>
              <div class="col">
                {{ $filters.currency(authorization.solde, authorization.cardholderCurrency ? authorization.cardholderCurrency : authorization.currencyCode) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.actualAmount') }}
              </div>
              <div class="col">
                {{ $filters.currency(authorization.actualAmount, authorization.cardholderCurrency ? authorization.cardholderCurrency : authorization.currencyCode) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.complementAmount') }}
              </div>
              <div class="col">
                {{ $filters.amountObject(authorization.complementAmount) }}
              </div>
            </div>
            <div
              v-if="authorization.accountDetailList && authorization.accountDetailList.accountDetail"
              class="row"
            >
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.accountDetailList') }}
              </div>
              <table
                class="table table-sm table-bordered table-striped"
                style="width: auto;"
              >
                <thead>
                  <tr>
                    <th style="white-space: nowrap;">{{ $t('label.authorization.detail.accountCategory') }}</th>
                    <th style="white-space: nowrap;">{{ $t('label.authorization.detail.accountNumber') }}</th>
                    <th style="white-space: nowrap;">{{ $t('label.authorization.detail.cashWithDrawalAccountAvailable') }}</th>
                    <th style="white-space: nowrap;">{{ $t('label.authorization.detail.purchaseAccountAvailable') }}</th>
                    <th style="white-space: nowrap;">{{ $t('label.authorization.detail.purchaseAccountAvailableException') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(accountDetail, index) in sortedAccountDetails"
                    :key="index"
                  >
                    <td>{{ accountDetail.accountCategory || 'Global' }}</td>
                    <td>{{ accountDetail.accountNumber }}</td>
                    <td>{{ $filters.amountObject(accountDetail.cashWithDrawalAccountAvailable) }}</td>
                    <td>{{ $filters.amountObject(accountDetail.purchaseAccountAvailable) }}</td>
                    <td>{{ $filters.amountObject(accountDetail.purchaseAccountAvailableException) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip4"
              class="d-none"
            >
              {{ $t('label.authorization.detail.amount') }} : {{ $filters.currency(authorization.oriAuthorization.amount, authorization.oriAuthorization.currencyCode) }} &lt;br&gt;
              {{ $t('label.authorization.detail.currencyCode') }} : {{ authorization.oriAuthorization.currencyCode }} &lt;br&gt;
              {{ $t('label.authorization.detail.replacementAmount') }} : {{ $filters.currency(authorization.oriAuthorization.replacementAmount, authorization.oriAuthorization.currencyCode) }} &lt;br&gt;
              {{ $t('label.authorization.detail.cardholderAmount') }} : {{ $filters.currency(authorization.oriAuthorization.cardholderAmount, authorization.oriAuthorization.cardholderCurrency ? authorization.oriAuthorization.cardholderCurrency : authorization.oriAuthorization.currencyCode) }} &lt;br&gt;
              {{ $t('label.authorization.detail.cardholderCurrency') }} : {{ authorization.oriAuthorization.cardholderCurrency }} &lt;br&gt;
              {{ $t('label.authorization.detail.cardholderConversionRate') }} : {{ authorization.oriAuthorization.cardholderConversionRate }} &lt;br&gt;
              {{ $t('label.authorization.detail.cardholderReplacementAmount') }} : {{ $filters.currency(authorization.oriAuthorization.cardholderReplacementAmount, authorization.oriAuthorization.cardholderCurrency ? authorization.oriAuthorization.cardholderCurrency : authorization.oriAuthorization.currencyCode) }} &lt;br&gt;
              {{ $t('label.authorization.detail.solde') }} : {{ $filters.currency(authorization.oriAuthorization.solde, authorization.oriAuthorization.cardholderCurrency ? authorization.oriAuthorization.cardholderCurrency : authorization.oriAuthorization.currencyCode) }} &lt;br&gt;
              {{ $t('label.authorization.detail.actualAmount') }} : {{ $filters.currency(authorization.oriAuthorization.actualAmount, authorization.oriAuthorization.cardholderCurrency ? authorization.oriAuthorization.cardholderCurrency : authorization.oriAuthorization.currencyCode) }} &lt;br&gt;
              {{ $t('label.authorization.detail.complementAmount') }} : {{ $filters.amountObject(authorization.oriAuthorization.complementAmount) }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionAuthData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingAuthData"
            data-bs-toggle="collapse"
            href="#collapseAuthData"
            aria-expanded="false"
            aria-controls="collapseAuthData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.authRespSpeciData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip5')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapseAuthData"
            aria-labelledby="headingAuthData"
            data-bs-parent="#accordionAuthData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.respAcceptorMessage') }}
              </div>
              <div class="col">
                {{ authorization.respAcceptorMessage }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.respIssuerMessage') }}
              </div>
              <div class="col">
                {{ authorization.respIssuerMessage }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.respPartialApprovalFlag') }}
              </div>
              <div class="col">
                {{ authorization.respPartialApprovalFlag }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.respCardStatus') }}
              </div>
              <div class="col">
                {{ authorization.respCardStatus }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.respCardExpiryDate') }}
              </div>
              <div class="col">
                {{ authorization.respCardExpiryDate }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip5"
              class="d-none"
            >
              {{ $t('label.authorization.detail.respAcceptorMessage') }} : {{ authorization.oriAuthorization.respAcceptorMessage }} &lt;br&gt;
              {{ $t('label.authorization.detail.respIssuerMessage') }} : {{ authorization.oriAuthorization.respIssuerMessage }} &lt;br&gt;
              {{ $t('label.authorization.detail.respPartialApprovalFlag') }} : {{ authorization.oriAuthorization.respPartialApprovalFlag }} &lt;br&gt;
              {{ $t('label.authorization.detail.respCardStatus') }} : {{ authorization.oriAuthorization.respCardStatus }} &lt;br&gt;
              {{ $t('label.authorization.detail.respCardExpiryDate') }} : {{ authorization.oriAuthorization.respCardExpiryDate }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionAnnulData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingAnnulData"
            data-bs-toggle="collapse"
            href="#collapseAnnulData"
            aria-expanded="false"
            aria-controls="collapseAnnulData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.annulRedresSpeciData') }} <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip6')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapseAnnulData"
            aria-labelledby="headingAnnulData"
            data-bs-parent="#accordionAnnulData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.oriAcquirerId') }}
              </div>
              <div class="col">
                {{ authorization.oriAcquirerId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.oriMontant') }}
              </div>
              <div class="col">
                {{ $filters.currency(authorization.oriMontant, authorization.currencyCode) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.oriDateTransaction') }}
              </div>
              <div class="col">
                {{ $filters.date(authorization.oriDateTransaction) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.oriTraceNumber') }}
              </div>
              <div class="col">
                {{ authorization.oriTraceNumber }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.onlinePartialReversalParam') }}
              </div>
              <div class="col">
                {{ translateOnlinePartialReversalParam(authorization.onlinePartialReversalParam) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.oriAuthorizationReference') }}
              </div>
              <div class="col">
                {{ authorization.oriAuthorizationReference }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip6"
              class="d-none"
            >
              {{ $t('label.authorization.detail.oriAcquirerId') }} : {{ authorization.oriAuthorization.idAcceptation }} &lt;br&gt;
              {{ $t('label.authorization.detail.oriMontant') }} : {{ $filters.currency(authorization.oriAuthorization.actualAmount, authorization.oriAuthorization.cardholderCurrency ? authorization.oriAuthorization.cardholderCurrency : authorization.oriAuthorization.currencyCode) }} &lt;br&gt;
              {{ $t('label.authorization.detail.oriDateTransaction') }} : {{ $filters.date(authorization.oriAuthorization.dateTransaction) }} &lt;br&gt;
              {{ $t('label.authorization.detail.oriTraceNumber') }} : {{ authorization.oriAuthorization.traceNumber }} &lt;br&gt;
              {{ $t('label.authorization.detail.onlinePartialReversalParam') }} : {{ translateOnlinePartialReversalParam(authorization.oriAuthorization.onlinePartialReversalParam) }} &lt;br&gt;
              {{ $t('label.authorization.detail.oriAuthorizationReference') }} : {{ authorization.oriAuthorization.authorizationReference }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionVaucherData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingVaucherData"
            data-bs-toggle="collapse"
            href="#collapseVaucherData"
            aria-expanded="false"
            aria-controls="collapseVaucherData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.vaucherData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip7')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapseVaucherData"
            aria-labelledby="headingVaucherData"
            data-bs-parent="#accordionVaucherData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.externalReference') }}
              </div>
              <div class="col">
                {{ authorization.externalReference }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.amountImpact') }}
              </div>
              <div class="col">
                {{ $filters.amountImpact(authorization.amountImpact, authorization.currencyCode) }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip7"
              class="d-none"
            >
              {{ $t('label.authorization.detail.externalReference') }} : {{ authorization.oriAuthorization.externalReference }} &lt;br&gt;
              {{ $t('label.authorization.detail.amountImpact') }} : {{ authorization.oriAuthorization.amountImpact }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionSecuData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingSecuData"
            data-bs-toggle="collapse"
            href="#collapseSecuData"
            aria-expanded="false"
            aria-controls="collapseSecuData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.securitairesData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip8')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapseSecuData"
            aria-labelledby="headingSecuData"
            data-bs-parent="#accordionSecuData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.transacIdAcceptor') }}
              </div>
              <div class="col">
                {{ authorization.transacIdAcceptor }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cryptogram') }}
              </div>
              <div class="col">
                {{ authorization.cryptogram }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.securityType') }}
              </div>
              <div class="col">
                {{ authorization.securityType }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cryptogramProcessInfo') }}
              </div>
              <div class="col">
                {{ authorization.cryptogramProcessInfo }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cardholderAuthMethod') }}
              </div>
              <div class="col">
                {{ authorization.cardholderAuthMethod }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.cryptogramCalcMethod') }}
              </div>
              <div class="col">
                {{ authorization.cryptogramCalcMethod }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.onBehalfServices') }}
              </div>
              <div class="col">
                {{ authorization.onBehalfServices }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.securityServicesData') }}
              </div>
              <div class="col">
                {{ authorization.securityServicesData }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.additionalData') }}
              </div>
              <div class="col">
                {{ authorization.additionalData }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.indicator') }}
              </div>
              <div class="col">
                {{ authorization.indicator }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.walletName') }}
              </div>
              <div class="col">
                {{ authorization.walletName }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.walletAdditionalData') }}
              </div>
              <div class="col">
                {{ authorization.walletAdditionalData }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.walletIdentifier') }}
              </div>
              <div class="col">
                {{ authorization.walletIdentifier }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenId') }}
              </div>
              <div class="col">
                {{ authorization.tokenId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenAccountNumber') }}
              </div>
              <div class="col">
                {{ authorization.tokenAccountNumber }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenExpiryDate') }}
              </div>
              <div class="col">
                {{ authorization.tokenExpiryDate }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenRequestorId') }}
              </div>
              <div class="col">
                {{ authorization.tokenRequestorId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenWalletId') }}
              </div>
              <div class="col">
                {{ authorization.tokenWalletId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenType') }}
              </div>
              <div class="col">
                {{ authorization.tokenType }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenStorageType') }}
              </div>
              <div class="col">
                {{ authorization.tokenStorageType }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.tokenAssuranceLevel') }}
              </div>
              <div class="col">
                {{ authorization.tokenAssuranceLevel }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.deviceType') }}
              </div>
              <div class="col">
                {{ authorization.deviceType }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.lastEmvCommandResult') }}
              </div>
              <div class="col">
                {{ authorization.lastEmvCommandResult }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.protocolVersion') }}
              </div>
              <div class="col">
                {{ authorization.protocolVersion }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.directoryServerTransactionId') }}
              </div>
              <div class="col">
                {{ authorization.directoryServerTransactionId }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.blockPINAlgorithm') }}
              </div>
              <div class="col">
                {{ authorization.blockPINAlgorithm }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.blockPINFormat') }}
              </div>
              <div class="col">
                {{ authorization.blockPINFormat }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.transactionAnalysisOverview') }}
              </div>
              <div class="col">
                {{ authorization.transactionAnalysisOverview }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.transactionAnalysisTestResults') }}
              </div>
              <div class="col">
                {{ authorization.transactionAnalysisTestResults }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip8"
              class="d-none"
            >
              {{ $t('label.authorization.detail.transacIdAcceptor') }} : {{ authorization.oriAuthorization.transacIdAcceptor }} &lt;br&gt;
              {{ $t('label.authorization.detail.cryptogram') }} : {{ authorization.oriAuthorization.cryptogram }} &lt;br&gt;
              {{ $t('label.authorization.detail.securityType') }} : {{ authorization.oriAuthorization.securityType }} &lt;br&gt;
              {{ $t('label.authorization.detail.cryptogramProcessInfo') }} : {{ authorization.oriAuthorization.cryptogramProcessInfo }} &lt;br&gt;
              {{ $t('label.authorization.detail.cardholderAuthMethod') }} : {{ authorization.oriAuthorization.cardholderAuthMethod }} &lt;br&gt;
              {{ $t('label.authorization.detail.cryptogramCalcMethod') }} : {{ authorization.oriAuthorization.cryptogramCalcMethod }} &lt;br&gt;
              {{ $t('label.authorization.detail.additionalData') }} : {{ authorization.oriAuthorization.additionalData }} &lt;br&gt;
              {{ $t('label.authorization.detail.indicator') }} : {{ authorization.oriAuthorization.indicator }} &lt;br&gt;
              {{ $t('label.authorization.detail.walletName') }} : {{ authorization.oriAuthorization.walletName }} &lt;br&gt;
              {{ $t('label.authorization.detail.walletAdditionalData') }} : {{ authorization.oriAuthorization.walletAdditionalData }} &lt;br&gt;
              {{ $t('label.authorization.detail.walletIdentifier') }} : {{ authorization.oriAuthorization.walletIdentifier }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenId') }} : {{ authorization.oriAuthorization.tokenId }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenAccountNumber') }} : {{ authorization.oriAuthorization.tokenAccountNumber }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenExpiryDate') }} : {{ authorization.oriAuthorization.tokenExpiryDate }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenRequestorId') }} : {{ authorization.oriAuthorization.tokenRequestorId }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenType') }} : {{ authorization.oriAuthorization.tokenType }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenStorageType') }} : {{ authorization.oriAuthorization.tokenStorageType }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenAssuranceLevel') }} : {{ authorization.oriAuthorization.tokenAssuranceLevel }} &lt;br&gt;
              {{ $t('label.authorization.detail.tokenWalletId') }} : {{ authorization.oriAuthorization.tokenWalletId }} &lt;br&gt;
              {{ $t('label.authorization.detail.lastEmvCommandResult') }} : {{ authorization.oriAuthorization.lastEmvCommandResult }} &lt;br&gt;
              {{ $t('label.authorization.detail.protocolVersion') }} : {{ authorization.oriAuthorization.protocolVersion }} &lt;br&gt;
              {{ $t('label.authorization.detail.directoryServerTransactionId') }} : {{ authorization.oriAuthorization.directoryServerTransactionId }} &lt;br&gt;
              {{ $t('label.authorization.detail.blockPINAlgorithm') }} : {{ authorization.oriAuthorization.blockPINAlgorithm }} &lt;br&gt;
              {{ $t('label.authorization.detail.blockPINFormat') }} : {{ authorization.oriAuthorization.blockPINFormat }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionAvisAuthData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingAvisAuthData"
            data-bs-toggle="collapse"
            href="#collapsAvisAuthData"
            aria-expanded="false"
            aria-controls="collapsAvisAuthData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.avisAuthSpeciData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="d-none float-end"
              @mouseover="getToolTipText('tooltip9')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapsAvisAuthData"
            aria-labelledby="headingAvisAuthData"
            data-bs-parent="#accordionAvisAuthData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.codeRetourRequest') }}
              </div>
              <div class="col">
                {{ authorization.codeRetourRequest }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.codeRetourDetailleRequest') }}
              </div>
              <div class="col">
                {{ authorization.codeRetourDetailleRequest }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.avisCodeMotif') }}
              </div>
              <div
                v-if="authorization.typeTransaction.includes('0120')"
                class="col"
              >
                {{ authorization.avisCodeMotif }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip9"
              class="d-none"
            >
              {{ $t('label.authorization.detail.codeRetourRequest') }} : {{ authorization.oriAuthorization.codeRetourRequest }} &lt;br&gt;
              {{ $t('label.authorization.detail.codeRetourDetailleRequest') }} : {{ authorization.oriAuthorization.codeRetourDetailleRequest }} &lt;br&gt;
              <span v-if="authorization.typeTransaction.includes('0120')">
                {{ $t('label.authorization.detail.avisCodeMotif') }} : {{ authorization.oriAuthorization.avisCodeMotif }}
              </span>
              <span v-if="!authorization.typeTransaction.includes('0120')">
                {{ $t('label.authorization.detail.avisCodeMotif') }} :
              </span> &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionScpData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingScpData"
            data-bs-toggle="collapse"
            href="#collapsScpData"
            aria-expanded="false"
            aria-controls="collapsScpData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.scpSpeciData') }}  <span
              v-if="authorization.oriAuthorizationReference"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipText('tooltip10')"
            ><i class="fas fa-info-circle fa-xs" /></span>
          </div>

          <div
            id="collapsScpData"
            aria-labelledby="headingScpData"
            data-bs-parent="#accordionScpData"
            class="card-body collapse"
          >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.scpRequestDate') }}
              </div>
              <div class="col">
                {{ $filters.date(authorization.scpRequestDate) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.scpResponseDate') }}
              </div>
              <div class="col">
                {{ $filters.date(authorization.scpResponseDate) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.substitutionPaymentReason') }}
              </div>
              <div class="col">
                {{ authorization.substitutionPaymentReason }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.scpResponseCode') }}
              </div>
              <div class="col">
                {{ authorization.scpResponseCode }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.scpNeedReversal') }}
              </div>
              <div class="col">
                {{ authorization.scpNeedReversal }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference"
              id="tooltip10"
              class="d-none"
            >
              {{ $t('label.authorization.detail.scpRequestDate') }} : {{ $filters.date(authorization.oriAuthorization.scpRequestDate) }} &lt;br&gt;
              {{ $t('label.authorization.detail.scpResponseDate') }} : {{ $filters.date(authorization.oriAuthorization.scpResponseDate) }} &lt;br&gt;
              {{ $t('label.authorization.detail.substitutionPaymentReason') }} : {{ authorization.oriAuthorization.substitutionPaymentReason }} &lt;br&gt;
              {{ $t('label.authorization.detail.scpResponseCode') }} : {{ authorization.oriAuthorization.scpResponseCode }} &lt;br&gt;
              {{ $t('label.authorization.detail.scpNeedReversal') }} : {{ authorization.oriAuthorization.scpNeedReversal }} &lt;br&gt;
            </div>
          </div>
        </div>

        <div
          id="accordionSaeCallData"
          class="card rounded-0 mb-4"
        >
          <div
            id="headingSaeCallData"
            data-bs-toggle="collapse"
            href="#collapsSaeCallData"
            aria-expanded="false"
            aria-controls="collapsSaeCallData"
            class="card-header font-accent fw-bold"
          >
            {{ $t('label.authorization.detail.saeCallData') }}
            <span
              v-if="authorization.oriAuthorizationReference && authorization.oriAuthorization.saeCallData"
              :title="toolTipVal"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              class="float-end"
              @mouseover="getToolTipTextList('tooltip11')"
            ><i class="fas fa-info-circle fa-xs" />
            </span>
          </div>

          <div
            v-for="(call, index) in authorization.saeCallData"
            id="collapsSaeCallData"
            :key="call.extSaeRequestDate"
            aria-labelledby="headingSaeCallData"
            data-bs-parent="#accordionSaeCallData"
            class="card-body collapse"
          >
            <hr
              v-if="index != 0"
              style="margin-top:-1em !important"
            >
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.accountAvailable') }}
              </div>
              <div class="col">
                {{ $filters.amountObject(call.accountAvailable) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.amountAdjusted') }}
              </div>
              <div class="col">
                {{ $filters.amountObject(call.amountAdjusted) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.extSaeRequestDate') }}
              </div>
              <div class="col">
                {{ $filters.date(call.extSaeRequestDate) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.extSaeResponseCode') }}
              </div>
              <div class="col">
                {{ call.extSaeResponseCode }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.extSaeResponseDate') }}
              </div>
              <div class="col">
                {{ $filters.date(call.extSaeResponseDate) }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.opType') }}
              </div>
              <div class="col">
                {{ call.opType }}
              </div>
            </div>
            <div class="row">
              <div class="col-3 text-end">
                {{ $t('label.authorization.detail.rejectNotificationReason') }}
              </div>
              <div class="col">
                {{ call.rejectNotificationReason }}
              </div>
            </div>
            <div
              v-if="authorization.oriAuthorizationReference && authorization.oriAuthorization.saeCallData"
              :id="'tooltip11' + index"
              class="d-none"
            >
              {{ $t('label.authorization.detail.accountAvailable') }} : {{ $filters.amountObject(authorization.oriAuthorization.saeCallData[index].accountAvailable) }} &lt;br&gt;
              {{ $t('label.authorization.detail.amountAdjusted') }} : {{ $filters.amountObject(authorization.oriAuthorization.saeCallData[index].amountAdjusted) }} &lt;br&gt;
              {{ $t('label.authorization.detail.extSaeRequestDate') }} : {{ $filters.date(authorization.oriAuthorization.saeCallData[index].extSaeRequestDate) }} &lt;br&gt;
              {{ $t('label.authorization.detail.extSaeResponseCode') }} : {{ authorization.oriAuthorization.saeCallData[index].extSaeResponseCode }} &lt;br&gt;
              {{ $t('label.authorization.detail.extSaeResponseDate') }} : {{ $filters.date(authorization.oriAuthorization.saeCallData[index].extSaeResponseDate) }} &lt;br&gt;
              {{ $t('label.authorization.detail.opType') }} : {{ authorization.oriAuthorization.saeCallData[index].opType }} &lt;br&gt;
              {{ $t('label.authorization.detail.rejectNotificationReason') }} : {{ authorization.oriAuthorization.saeCallData[index].rejectNotificationReason }} &lt;br&gt;
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./AuthorizationDetail.js"></script>

<style src="./AuthorizationDetail.scss" scoped lang="scss"></style>
